import dialogSkin from "../common/dialog.skin";

const filteringDialogSkin = {
  ...dialogSkin,
  "form-fields": {
    "overflow-x": "hidden",
    "overflow-y": "auto",
    position: "relative",
    "max-height": "calc(100vh - 240px)",
  },
};

export default filteringDialogSkin;
